<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/goodslist' }">首页管理</el-breadcrumb-item>
            <el-breadcrumb-item>关于VOM</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区-->
        <el-card>
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px" style="width:90%;margin:10px auto">
                    <el-form-item label="关于VOM" prop="param7">
                        <myeditor @editorContent="change($event)" :str="editForm.param7"></myeditor>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="EditSave">确 定</el-button>
                        <el-button >取 消</el-button>
                    </el-form-item>
                </el-form>
        </el-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            imgURL:this.GLOBAL.imgURL,
            uploadurl: this.GLOBAL.imgURL+'upload/',
            limitNum: 1,
            fileList:[],
            classlist:[],
            brandlist:[],
            id:'',
            //编辑表单数据
            editForm:{},
            //编辑表单验证规则
            editFormRules:{
                param7:[
                    { required: true, message: '请输入参数', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        this.editParams()
    },
    methods:{
        async editParams(){
            const { data: res } = await this.$http.get('paramsinfo/1')
            this.editForm = res.data
            console.log(this.editForm);
        },
        change(data) {
            this.editForm.param7 = data;
        },
        async EditSave(){
              this.$refs.editFormRef.validate( async valid=>{
                if (!valid) return
                const { data:res } = await this.$http.post('aboutsedit/1',this.editForm)
                if(res.status===0)
                {
                    this.$message.success('修改参数成功！')
                    this.$router.push({path: '/abouts'})
                }
              })
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
        
    }
    .el-breadcrumb{
        width: 100%;
    }
    
</style>